import { Action } from 'shared/store/types';
import actionTypes from './actionTypes';


const defaultState = {
  images: [],
  imagesWithInfo: [],
  productId: null,
  totalImagesAvailable: 0,
  loading: false,
  isNotFound: false,
  isFetchingError: false,
  hasLoaded: false,
};

const ReviewImages = (
  state = defaultState,
  action: Action,
) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.REVIEW_IMAGES_FETCHING:
      if (payload.newProduct) {
        return { ...defaultState, loading: true, isNotFound: false, isFetchingError: false };
      }
      return {
        ...state,
        loading: true,
        isNotFound: false,
        isFetchingError: false,
        hasLoaded: false,
      };

    case actionTypes.REVIEW_IMAGES_SUCCESS:
      return {
        ...state,
        totalImagesAvailable: payload.totalImagesAvailable || state.totalImagesAvailable,
        loading: false,
        isNotFound: false,
        isFetchingError: false,
        nextPageKey: payload.nextPageKey,
        images: [
          ...state.images,
          ...payload.images,
        ],
        imagesWithInfo: [
          ...state.imagesWithInfo,
          ...payload.imagesWithInfo,
        ],
        productId: payload.productId,
        hasLoaded: true,
      };

      case actionTypes.REVIEW_IMAGES_NOT_FOUND:
        return {
          ...state,
          loading: false,
          isNotFound: true,
          isFetchingError: false,
        };

      case actionTypes.REVIEW_IMAGES_FAILED:
        return {
          ...state,
          loading: false,
          isNotFound: false,
          isFetchingError: true,
        };

    default:
      return state;
  }
};


export default ReviewImages;
